import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"

export default function DesktopFacet({ facet, isOpen, onToggle }) {
    const { selectedFiltersCount, toggleProductFilter } = useFacet(facet)

    const handleToggle = (event) => {
        event.stopPropagation()
        onToggle(facet.id, !isOpen)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Escape' && isOpen) {
            event.stopPropagation()
            onToggle(facet.id, false)
        }
    }


    return (
        <div className="ns-desktop-filter-single" data-facet-id={facet.id} onKeyDown={handleKeyDown}>
            <button
                type="button"
                className={`ns-desktop-filter-head ${isOpen ? 'is-active' : ''}`}
                onClick={handleToggle}
                aria-expanded={isOpen}
                aria-controls={`${facet.id}-desktop-menu`}
                aria-label={`${facet.name}, ${selectedFiltersCount} selected`}
            >
                <span className="ns-desktop-filter-label" aria-hidden="true">{facet.name}</span>
                <span className="ns-desktop-filter-arrow" aria-hidden="true"></span>
            </button>
            
            <ul 
                className={`ns-desktop-filter-list ${isOpen ? 'is-active' : ''}`}
                id={`${facet.id}-desktop-menu`}
                onClick={(e) => e.stopPropagation()}
            >
                {facet.data?.map(value => (
                    <li key={value.value} className="ns-desktop-filter-item">
                        <Checkbox
                            className="ns-desktop-filter-checkbox"
                            value={value.value}
                            count={value.count}
                            selected={value.selected}
                            onChange={(e) => {
                                e.preventDefault()
                                toggleProductFilter(facet.field, value.value, !value.selected)
                            }}
                        />
                    </li>
                ))}
            </ul>
        </div>
    )
}
